export const inEnglandQuestion = 'In England?';
export const NHSLoginError = 'Something went wrong. Please try again.';

export const accessNHS = 'Free access through the NHS';
export const accessResearch = 'I am part of a Research Study';
export const accessEmployer = 'I work for Google';
